<template>
    <div class="loader-blue"></div>
</template>

<script>
export default {
    name: 'Loader'
}
</script>
